import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { QUERY_LLM_STRATEGY_BY_ID } from "../../common";
import { AiStrategy } from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import {
  ManageLlmStrategiesParamList,
  ViewLlmStrategyRootScreenParamList,
} from "../../../../types";
import { useLazyQuery } from "@apollo/client";
import { ViewLlmStrategyScreen } from "./ViewLlmStrategyScreen";
import { ScreenContext } from "./common";
import { UpdateLlmModelScreen } from "./UpdateLlmModelScreen";
import { GenericUpdateLlmConfigScreen } from "./GenericUpdateLlmConfigScreen";

const Stack = createStackHeaderNavigator<ViewLlmStrategyRootScreenParamList>();

export interface ViewLlmStrategyScreenProps
  extends StackScreenProps<
    ManageLlmStrategiesParamList,
    "ViewLlmStrategyRootScreen"
  > {}

export const ViewLlmStrategyRootScreen = ({
  navigation,
  route,
}: ViewLlmStrategyScreenProps) => {
  const [aiStrategy, setLlmStrategy] = React.useState<AiStrategy | undefined>(
    undefined
  );

  const handleSetStrategy = React.useCallback(
    (strategy: AiStrategy | undefined) => {
      setLlmStrategy(strategy);
    },
    []
  );

  const [queryLlmStrategyById] = useLazyQuery<{
    aiStrategy: AiStrategy;
  }>(QUERY_LLM_STRATEGY_BY_ID);

  React.useEffect(() => {
    (async () => {
      try {
        const aiStrategyResult = await queryLlmStrategyById({
          variables: { id: route.params.llmStrategyId },
        });
        setLlmStrategy(aiStrategyResult.data?.aiStrategy);
      } catch (error) {
        console.error("Error fetching LLM strategy:", error);
      }
    })();
  }, [navigation, queryLlmStrategyById]);

  return (
    <ScreenContext.Provider
      value={{
        data: { strategy: aiStrategy },
        setStrategy: handleSetStrategy,
      }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          headerShown: false,
          title: "",
        }}
      >
        <Stack.Group
          screenOptions={{
            headerShown: true,
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <Stack.Screen
            name="ViewLlmStrategyScreen"
            component={ViewLlmStrategyScreen}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{
            headerShown: true,
            headerLeft: () => <ModalCloseButton type="Cancel" />,
          }}
        >
          <Stack.Screen
            name="UpdateLlmModelScreen"
            component={UpdateLlmModelScreen}
          />
          <Stack.Screen
            name="GenericUpdateLlmConfigScreen"
            component={GenericUpdateLlmConfigScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </ScreenContext.Provider>
  );
};
